<template>
  <div class="company-logo">
    <img
      v-if="useImage"
      class="company-logo__img"
      :src="getLogoUrl"
      :alt="alternativeText"
      @error="handleImageError"
    >
    <UkaskoGrayIcon v-else class="company-logo__placeholder" />
  </div>
</template>

<script>
import { Env } from '@/shared/config/environment';
import { UkaskoGrayIcon } from '@/shared/ui/icons';

export default {
  props: {
    logo: {
      type: String,
      default: '',
    },
    alternativeText: {
      type: String,
      default: '',
    },
  },
  components: { UkaskoGrayIcon },
  data() {
    return {
      useImage: !!this.logo,
    };
  },
  computed: {
    getLogoUrl() {
      if (!this.logo) return '';
      if (this.logo.startsWith('http://') || this.logo.startsWith('https://')) return this.logo;
      return this.trimSlash(Env.server.admin, 'end') + '/' + this.trimSlash(this.logo, 'start');
    },
  },
  methods: {
    trimSlash(str, position = 'end') {
      if (typeof str !== 'string') return str;

      switch (position) {
        case 'start':
          return str.replace(/^\/+/, '');
        case 'end':
          return str.replace(/\/+$/, '');
        case 'both':
          return str.replace(/^\/+|\/+$/g, '');
        default:
          return str;
      }
    },
    handleImageError() {
      this.useImage = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.company-logo {
  &__img,
  &__placeholder {
    max-width: 40px;
    max-height: 40px;
    margin-right: 12px;
  }
}
</style>
